import React, { useState } from 'react';
import { Button } from 'modules';
import { useMutation } from '@apollo/react-hooks';
import { SignContractOnlineFormMutation } from 'queries/ContractOnlineForms/ContractOnlineFormData';
import { notifyFailed, notifySuccess } from 'helpers/notify';
import SignWithSms from 'components/SignWithSms';
import { TARIFFS } from 'constants/Tariffs';
import { signLifewayConsultant } from 'apis/Lifeway';

interface ConfirmToSignData {
  form: {
    id: string;
  };
  contractId: string;
  productId: number;
  mobil: string;
}

interface ButtonAcceptToSignProps {
  disabled?: boolean;
  data: ConfirmToSignData;
  onSubmit: () => void;
}

const ButtonAcceptToSign = ({ data, disabled, onSubmit }: ButtonAcceptToSignProps) => {
  const [displayConfirm, setDisplayConfirm] = useState(false);
  const [signForm] = useMutation(SignContractOnlineFormMutation);

  const toggleOpenConfirm = (): void => {
    setDisplayConfirm((prev) => !prev);
  };

  const onSubmitSign = (signature: GQL.ISignature) => {
    // uložím potvrzení podpisu formuláře
    signForm({
      variables: {
        id: data.form.id,
        signatureId: signature.id,
      },
    })
      .then((result) => result.data.signContractOnlineForm)
      .then(async (result) => {
        if (result) {
          // request pro založení registrace v lifeway
          if (data.productId === TARIFFS.OBO_LW) {
            await signLifewayConsultant({
              contractId: data.contractId,
            });
          }
          // notifikace
          notifySuccess('Gratulujeme, zmluva bola podpísaná!');
          onSubmit();
          toggleOpenConfirm();
        }
      })
      .catch((error) => {
        notifyFailed(error.message);
      });
  };

  return (
    <>
      <Button type={'submit'} variant={'danger'} className="ml-1" disabled={disabled} onClick={toggleOpenConfirm}>
        Objednávka s povinnosťou platby
      </Button>
      {displayConfirm === true && (
        <SignWithSms
          title="Potvrdenie objednávky"
          labelSignFor="potvrdenie objednávky"
          labelSubmit="Podpísať"
          phone={data.mobil}
          onSubmit={onSubmitSign}
          onClose={toggleOpenConfirm}
        />
      )}
    </>
  );
};

export default ButtonAcceptToSign;
